import {faCode, faPalette, faServer} from "@fortawesome/free-solid-svg-icons";
import HtmlIcon from '@mui/icons-material/Html';
import {JavascriptOutlined} from "@mui/icons-material";
import { IconCode, IconSchool, IconBackpack, IconLink, IconDeviceImacCode,IconWriting } from '@tabler/icons-react';
import { IconCertificate } from '@tabler/icons-react';
export const education_data = [
    {
        date: "2022 - 2023",
        title: "Master 2 - Spécialité MBDS",
        description: "Parcours mobiquité, big data et intégration de systèmes",
        location: "Sophia-Antipolis, France",
        icon: <IconCertificate />,
        buttonIcon: {
            icon: <IconLink />,
            link: "https://univ-cotedazur.fr/formation/offre-de-formation/parcours-mobiquite-big-data-et-integration-de-systemes-mbds",
            linkName: 'Plus d\'infos'
        },
        tags: [ "Developpement IOS", "No SQL", "SQL3", "Gestion de projet", "Big Data", "Analyse de donnée - R", "Machine Learning"],
    },
    {
        date: "2022 - 2023",
        title: "Master 1 - Informatique",
        description: "Innovation et transformation numérique de l'entreprise (MIAGE)",
        location: "Sophia-Antipolis, France",
        icon: <IconSchool />,
        tags: [ "Gestion d'entreprise", "Management", "Angular", "Gestion de projet"],
    },
    {
        date: "2021 - 2022",
        title: "Licence 3 - Informatique",
        description: "Université de Nice Sophia-Antipolis (MIAGE)",
        location: "Sophia-Antipolis, France",
        icon: <IconBackpack />,
        tags: [ "Gestion d'entreprise", "Management", "Graphisme"],
    },
    {
        date: "2019 - 2021",
        title: "Diplôme Universitaire Technologique Informatique",
        description: "Université de Nice (DUT)",
        location: "Nice, France",
        icon: <IconCode />,
        tags: [ "C", "Java", "SQL", "HTML", "CSS", "Javascript", "PHP", "Gestion de projet"],
    },
];
export const colorsChip = [
    "#d62828", "#f95738", "#f6aa1c", "#38a3a5", "#57cc99", "#3d348b", "#003049", "#3c096c",
]
export const experience_data = [
    {
        date: "2022 - Aujourd'hui",
        title: "Projet Studio graphisme - Mantaria Studio",
        description: "Création et gestion de la structure Mantaria Studio, une agence spécialisée en communication visuelle.",
        logo: "assets/logoMantaria.png",
        buttonIcon: {
            icon: <IconLink />,
            link: "https://discord.com/invite/ywmYrQ9Bbm",
            linkName: 'Voir plus'
        },
        idImage: "mantaria",
        location: "Nice, France",
        icon: <IconWriting />,
        tags: [ "Gestion d'entreprise", "Management", "Graphisme"],
    },
    {
        date: "2022 - 2024",
        title: "Alternant - Développeur full-stack",
        description: "Alithya France - Alternance de fin d'année de Master",
        logo: "https://upload.wikimedia.org/wikipedia/commons/0/09/Alithya.png",
        location: "Sophia-Antipolis, France",
        idImage: "image-no-background",
        icon: <IconDeviceImacCode />,
        tags: [ "Angular 12", "Angular material", "React JS", "Java spring"],
    },
    {
        date: "2021 - 2022",
        title: "Membre de la Junior-Entreprise",
        description: "Chef de projet, commercial et membre du pôle SI (Système d'information)",
        logo: "https://upload.wikimedia.org/wikipedia/commons/7/7d/JE_logo.png",
        idImage: "image-no-background",
        location: "Sophia-Antipolis, France",
        icon: <IconSchool />,
        tags: [ "Chef de projet", "Suivi des intervenants", "Rédaction proposition commmercial", "Convention de cadre", "Cahier des charges", "cadre légale", "Gestion de projet"],
    },
];

export const skills_data = [
    {
        nameCategory: "Front-end developpement",
        icons: faCode,
        skills: [
            {
                name: "React (JS/TS)",
                level: 85,
            },
            {
                name: "Angular",
                level: 75,
            },
            {
                name: "Vue JS",
                level: 50,
            },
            {
                name: "ASP .NET Core",
                level: 70,
            },
            {
                name: "Flutter",
                level: 60,
            },
            {
                name: "JavaScript",
                level: 80,
            },
        ],
    },
    {
        nameCategory: "Back-end developpement",
        icons: faServer,
        skills: [
            {
                name: "Java",
                level: 85
            },
            {
                name: "Java Spring",
                level: 80,
            },
            {
                name: "Typescript",
                level: 60,
            },
            {
                name: "C#",
                level: 50,
            },
            {
                name: "Kotlin/Java - Android",
                level: 65,
            },
            {
                name: "Swift / SwiftUI - iOS",
                level: 60,
            },
            {
                name: "SQL (MariaDB/Postgres/MySQL)",
                level: 60,
            },
            {
                name: "No SQL : MongoDB",
                level: 70,
            },
            {
                name: "Node / Express",
                level: 70,
            },
            {
                name: "Docker / Docker-compose",
                level: 60,
            }
        ],
    },
    {
        nameCategory: "Graphisme",
        icons: faPalette,
        skills: [
            {
                name: "Photoshop",
                level: 40,
            },
            {
                name: "Illustrator",
                level: 50,
            },
            {
                name: "Figma",
                level: 75,
            },
            {
                name: "Spline - 3D Design",
                level: 55,
            }
        ],
    }
];
